import { SET_STORES_IN_STORE } from '../types';

export const setStoresInStore = (data) => {
  return {
    type: SET_STORES_IN_STORE,
    data,
  };
};
